import * as actionTypes from 'store/actions/actionTypes';
import { centsify, calcGST } from 'store/utility';

const localStoragedKey = 'qrCodeData';

let initState = {
  items: [],
};

const previousState = JSON.parse(localStorage.getItem(localStoragedKey));

if (previousState !== null) {
  initState = previousState;
}

/*
    - updateItems takes in the initial state and updated data
    - iterates through the initial items
    - returns a copy of the new state
*/
const updateItems = (items, id, value, settings) => {
  const {
    price: { price, gst },
    price_sale: { price_sale },
    unit,
    remark,
  } = value;

  const priceCents = centsify(price);
  const priceFormat = calcGST(price, gst ? gst : settings.gst || 0, 'cents');

  const priceSale = centsify(price_sale);
  const priceSaleFormat = calcGST(price_sale, gst ? gst : settings.gst || 0, 'cents');

  const idx = items.map(e => e.id).indexOf(id);
  const newState = items.map(e => ({ ...e }));
  newState[idx]['price_sale'] = priceSale;
  newState[idx]['price_sale_format'] = priceSaleFormat;
  newState[idx]['price_cents'] = priceCents;
  newState[idx]['price_format'] = priceFormat;
  newState[idx]['remark'] = remark;
  newState[idx]['price_unit'] = unit;
  newState[idx]['gst'] = gst;
  return newState;
};

const saveChangeToLocalStoraged = (state = initState) => {
  localStorage.setItem(localStoragedKey, JSON.stringify(state));
  return state;
};

export default (state = initState, action) => {
  let newState = { ...state };
  const { settings } = action;
  switch (action.type) {
    case actionTypes.WRITE_QRCODE_END:
      const { products } = action;
      // unique referential ids
      const result = state['items'].concat([...products]);
      newState['items'] = result.map(item => {
        const { price_cents, price_sale, gst } = item;

        const priceFormat = calcGST(price_cents / 100, gst ? gst : settings.gst || 0, 'cents');
        const priceSaleFormat = calcGST(price_sale / 100, gst ? gst : settings.gst || 0, 'cents');

        return {
          ...item,
          price_format: priceFormat,
          price_sale_format: priceSaleFormat,
        };
      });
      break;
    case actionTypes.CLEAR_QRCODE_END:
      newState = {
        items: [],
      };
      break;
    case actionTypes.DELETE_QRCODE_END:
      const { id } = action;
      const { items } = state;
      newState['items'] = items.filter(e => e.id !== id);
      break;
    case actionTypes.UPDATE_QRCODE_STORE:
      const { data, value } = action;
      newState['items'] = updateItems(state.items, data.id, value, settings);
      break;
    case actionTypes.SYNC_SETTING_QRCODE:
      newState['items'] = state.items.map(e => {
        const { price_cents, price_sale, gst } = e;
        const priceFormat = calcGST(price_cents / 100, gst ? gst : settings.gst || 0, 'cents');
        const priceSaleFormat = calcGST(price_sale / 100, gst ? gst : settings.gst || 0, 'cents');

        return {
          ...e,
          price_format: priceFormat,
          price_sale_format: priceSaleFormat,
        };
      });
      break;
    default:
      newState = state;
      break;
  }
  return saveChangeToLocalStoraged(newState);
};



// WEBPACK FOOTER //
// ./src/store/reducers/QRcode.js